import { map, toArray, iterate, fold } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { Player__get_CurrentWeapon, PlayerWeapon__get_CurrentSprite, Enemy__get_DirectionVector, Enemy__get_BaseSpriteIndexForState, Vector2D__Rotate_Z114CB6F, Vector2D__Normalize, degreesToRadians, Enemy__get_IsAlive, GameObject__get_BasicGameObject, firingTolerance, WallRenderingResult, textureHeight, Side, textureWidth, Vector2D } from "../Model.fs.js";
import { isPointInTriangle, cast } from "./Ray.fs.js";
import { iterate as iterate_1, fold as fold_1, empty, singleton, append, item, length } from "../fable_modules/fable-library.3.7.14/List.js";
import { uncurry, equals, min, comparePrimitives, max } from "../fable_modules/fable-library.3.7.14/Util.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.14/Range.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library.3.7.14/Int32.js";
import { bind, defaultArg } from "../fable_modules/fable-library.3.7.14/Option.js";
import { tryFindIndex } from "../fable_modules/fable-library.3.7.14/Array.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.14/String.js";

export function Walls_draw(width, height, setPixel, getTextureStripOffset, getTextureColor, game) {
    const posX = game.Camera.Position.vX;
    const posY = game.Camera.Position.vY;
    const viewportWidth = width;
    const viewportHeight = height;
    return fold((previousResult, viewportX) => {
        const cameraX = ((2 * viewportX) / viewportWidth) - 1;
        const rayDirection = new Vector2D(game.Camera.Direction.vX + (game.Camera.Plane.vX * cameraX), game.Camera.Direction.vY + (game.Camera.Plane.vY * cameraX));
        const patternInput = cast(() => [false, posX, posY, rayDirection], (tupledArg) => {
            const mapX = tupledArg[3] | 0;
            const mapY = tupledArg[4] | 0;
            if (!tupledArg[0]) {
                if (((mapX >= 0) && (mapX < length(item(0, game.Map)))) && (mapY >= 0)) {
                    return mapY < length(game.Map);
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }, game);
        const side = patternInput[7];
        const hitMapY = patternInput[6] | 0;
        const hitMapX = patternInput[5] | 0;
        const perpendicularWallDistance = (side.tag === 1) ? (patternInput[4] - patternInput[2]) : (patternInput[3] - patternInput[1]);
        const perpendicularWallDistance_1 = (item(hitMapX, item(hitMapY, game.Map)).tag === 1) ? (perpendicularWallDistance + 0.5) : perpendicularWallDistance;
        const lineHeight = viewportHeight / perpendicularWallDistance_1;
        const startY = max(comparePrimitives, ((-lineHeight) / 2) + (viewportHeight / 2), 0);
        const endY = min(comparePrimitives, (lineHeight / 2) + (viewportHeight / 2), viewportHeight - 1);
        let renderedPartOfDoor;
        const matchValue_1 = item(hitMapX, item(hitMapY, game.Map));
        switch (matchValue_1.tag) {
            case 0: {
                const wall = matchValue_1.fields[0];
                const wallX = (side.tag === 1) ? (posX + (perpendicularWallDistance_1 * rayDirection.vX)) : (posY + (perpendicularWallDistance_1 * rayDirection.vY));
                const rawTextureX = (~(~((wallX - Math.floor(wallX)) * textureWidth))) | 0;
                const patternInput_1 = (equals(side, new Side(0)) && (rayDirection.vX > 0)) ? [(textureWidth - rawTextureX) - 1, wall.NorthSouthTextureIndex] : ((equals(side, new Side(1)) && (rayDirection.vY < 0)) ? [(textureWidth - rawTextureX) - 1, wall.EastWestTextureIndex] : [rawTextureX, equals(side, new Side(0)) ? wall.NorthSouthTextureIndex : wall.EastWestTextureIndex]);
                const lineHeight_1 = viewportHeight / perpendicularWallDistance_1;
                const step = (1 * textureHeight) / lineHeight_1;
                const texPos = ((startY - (viewportHeight / 2)) + (lineHeight_1 / 2)) * step;
                const textureOffset = getTextureStripOffset(patternInput_1[1], ~(~patternInput_1[0]));
                iterate((drawY) => {
                    setPixel(getTextureColor(textureOffset, (~(~(texPos + (step * drawY)))) & ((~(~textureHeight)) - 1)), ~(~viewportX), drawY + (~(~startY)));
                }, rangeDouble(0, 1, ~(~(endY - startY))));
                renderedPartOfDoor = false;
                break;
            }
            case 1: {
                const door = item(matchValue_1.fields[0], game.Doors);
                const wallX_1 = equals(side, new Side(0)) ? (posY + (perpendicularWallDistance_1 * rayDirection.vY)) : (posX + (perpendicularWallDistance_1 * rayDirection.vX));
                const lineHeight_2 = viewportHeight / perpendicularWallDistance_1;
                const step_1 = (1 * textureHeight) / lineHeight_2;
                const texPos_1 = ((startY - (viewportHeight / 2)) + (lineHeight_2 / 2)) * step_1;
                const textureOffset_1 = getTextureStripOffset(door.TextureIndex, ~(~max(comparePrimitives, 0, ((textureWidth - (~(~((wallX_1 - Math.floor(wallX_1)) * textureWidth)))) - 1) - door.Offset)));
                iterate((drawY_1) => {
                    setPixel(getTextureColor(textureOffset_1, (~(~(texPos_1 + (step_1 * drawY_1)))) & ((~(~textureHeight)) - 1)), ~(~viewportX), drawY_1 + (~(~startY)));
                }, rangeDouble(0, 1, ~(~(endY - startY))));
                renderedPartOfDoor = true;
                break;
            }
            default: {
                renderedPartOfDoor = false;
            }
        }
        return new WallRenderingResult(append(previousResult.ZIndexes, singleton(perpendicularWallDistance_1)), (viewportX === (viewportWidth / 2)) ? [hitMapX, hitMapY] : previousResult.WallInFrontOfPlayer, (viewportX === (viewportWidth / 2)) ? renderedPartOfDoor : previousResult.IsDoorInFrontOfPlayer, (viewportX === (viewportWidth / 2)) ? perpendicularWallDistance_1 : previousResult.DistanceToWallInFrontOfPlayer, previousResult.SpriteInFrontOfPlayerIndexOption);
    }, new WallRenderingResult(empty(), [-1, -1], false, -1, void 0), rangeDouble(0, 1, viewportWidth - 1));
}

export function Objects_draw(width, height, getPixel, setPixel, isTransparent, getSpriteOffsets, game, sprites, wallRenderResult) {
    const planeX = game.Camera.Plane.vX;
    const planeY = game.Camera.Plane.vY;
    const dirX = game.Camera.Direction.vX;
    const dirY = game.Camera.Direction.vY;
    const hitDetectionLeft = ((~(~((~(~width)) / 2))) - (~(~(firingTolerance / 2)))) | 0;
    const hitDetectionRight = (hitDetectionLeft + firingTolerance) | 0;
    return new WallRenderingResult(wallRenderResult.ZIndexes, wallRenderResult.WallInFrontOfPlayer, wallRenderResult.IsDoorInFrontOfPlayer, wallRenderResult.DistanceToWallInFrontOfPlayer, fold_1(uncurry(2, (tupledArg_1) => {
        const gameObjectIndex = tupledArg_1[1] | 0;
        return (sprite) => {
            const spriteX = GameObject__get_BasicGameObject(sprite).Position.vX - game.Camera.Position.vX;
            const spriteY = GameObject__get_BasicGameObject(sprite).Position.vY - game.Camera.Position.vY;
            const invDet = 1 / ((planeX * dirY) - (planeY * dirX));
            const transformY = invDet * (((-planeY) * spriteX) + (planeX * spriteY));
            const spriteScreenX = (width / 2) * (1 + ((invDet * ((dirY * spriteX) - (dirX * spriteY))) / transformY));
            const spriteHeight = (~(~Math.abs(height / transformY))) | 0;
            const drawStartY = max(comparePrimitives, 0, (~(~(op_UnaryNegation_Int32(spriteHeight) / 2))) + (~(~((~(~height)) / 2)))) | 0;
            const drawEndY = min(comparePrimitives, (~(~height)) - 1, (~(~(spriteHeight / 2))) + (~(~((~(~height)) / 2)))) | 0;
            const spriteWidth = (~(~Math.abs(height / transformY))) | 0;
            const drawStartX = max(comparePrimitives, 0, (~(~(op_UnaryNegation_Int32(spriteWidth) / 2))) + (~(~spriteScreenX))) | 0;
            const drawEndX = min(comparePrimitives, (~(~width)) - 1, (~(~(spriteWidth / 2))) + (~(~spriteScreenX))) | 0;
            let spriteIndex;
            const gameObject = sprite;
            if (gameObject.tag === 1) {
                const e = gameObject.fields[0];
                spriteIndex = (Enemy__get_IsAlive(e) ? defaultArg(bind((directionVector) => {
                    const matchValue = e.State;
                    switch (matchValue.tag) {
                        case 7:
                        case 4:
                        case 2:
                        case 5: {
                            return void 0;
                        }
                        default: {
                            const spriteQuadrants = 8;
                            const quadrantSize = degreesToRadians(360 / spriteQuadrants);
                            const playerRelativePosition = Vector2D__Normalize(new Vector2D(game.Camera.Position.vX - e.BasicGameObject.Position.vX, game.Camera.Position.vY - e.BasicGameObject.Position.vY));
                            const playerTestPoint = new Vector2D(playerRelativePosition.vX / 2, playerRelativePosition.vY / 2);
                            const p1 = new Vector2D(0, 0);
                            const quadrantIndex = defaultArg(tryFindIndex((tupledArg) => isPointInTriangle(p1, tupledArg[0], tupledArg[1], playerTestPoint), toArray(map((quadrant) => {
                                const centerAngle = quadrant * quadrantSize;
                                const endAngle = centerAngle + (quadrantSize / 2);
                                return [Vector2D__Rotate_Z114CB6F(directionVector, centerAngle - (quadrantSize / 2)), Vector2D__Rotate_Z114CB6F(directionVector, endAngle)];
                            }, rangeDouble(0, 1, spriteQuadrants - 1)))), 0) | 0;
                            return Enemy__get_BaseSpriteIndexForState(e) + quadrantIndex;
                        }
                    }
                }, Enemy__get_DirectionVector(e)), Enemy__get_BaseSpriteIndexForState(e)) : item(e.CurrentAnimationFrame, e.DeathSpriteIndexes));
            }
            else {
                spriteIndex = gameObject.fields[0].SpriteIndex;
            }
            const spriteTexture = sprites[spriteIndex];
            const lineHeight = height / transformY;
            const step = (1 * textureHeight) / lineHeight;
            return ((drawStartX >= 0) && (drawEndX < (~(~width)))) ? [fold((gameObjectHitIndex, stripe) => {
                const textureX = (~(~((~(~(((256 * (stripe - ((op_UnaryNegation_Int32(spriteWidth) / 2) + spriteScreenX))) * 64) / spriteWidth))) / 256))) | 0;
                if ((((transformY > 0) && (stripe > 0)) && (stripe < (~(~width)))) && (transformY < item(stripe, wallRenderResult.ZIndexes))) {
                    iterate((y_4) => {
                        const color = getPixel(spriteTexture, textureX, ~(~(((y_4 - (height / 2)) + (lineHeight / 2)) * step)));
                        if (!isTransparent(color)) {
                            setPixel(color, stripe, y_4);
                        }
                    }, rangeDouble(drawStartY, 1, drawEndY - 1));
                    if ((GameObject__get_BasicGameObject(sprite).CollidesWithBullets && (stripe > hitDetectionLeft)) && (stripe < hitDetectionRight)) {
                        return gameObjectIndex;
                    }
                    else {
                        return gameObjectHitIndex;
                    }
                }
                else {
                    return gameObjectHitIndex;
                }
            }, tupledArg_1[0], rangeDouble(drawStartX, 1, drawEndX - 1)), gameObjectIndex + 1] : [void 0, 0];
        };
    }), [void 0, 0], game.GameObjects)[0]);
}

export function Weapons_drawPlayerWeapon(canvasWidth, canvasHeight, getPixel, setPixel, isTransparent, game) {
    const weapon = item(game.Player.CurrentWeaponIndex, game.Player.Weapons);
    const targetWidth = (canvasHeight / PlayerWeapon__get_CurrentSprite(weapon).Height) * PlayerWeapon__get_CurrentSprite(weapon).Width;
    const xPos = (canvasWidth / 2) - (targetWidth / 2);
    const scaleX = targetWidth / PlayerWeapon__get_CurrentSprite(weapon).Width;
    const scaleY = canvasHeight / PlayerWeapon__get_CurrentSprite(weapon).Height;
    iterate((spriteX) => {
        iterate((spriteY) => {
            const color = getPixel(PlayerWeapon__get_CurrentSprite(weapon), spriteX, spriteY);
            if ((!isTransparent(color)) && (color !== 0)) {
                const fromX = (~(~(xPos + (spriteX * scaleX)))) | 0;
                const fromY = (~(~(spriteY * scaleY))) | 0;
                const toY = (fromY + (~(~scaleY))) | 0;
                iterate((outX) => {
                    iterate((outY) => {
                        setPixel(color, outX, outY);
                    }, rangeDouble(fromY, 1, toY));
                }, rangeDouble(fromX, 1, fromX + (~(~scaleX))));
            }
        }, rangeDouble(0, 1, PlayerWeapon__get_CurrentSprite(weapon).Height - 1));
    }, rangeDouble(0, 1, PlayerWeapon__get_CurrentSprite(weapon).Width - 1));
}

export function StatusBar_drawStatusBar(statusBarGraphics, drawImage, game) {
    let index;
    const playerHp = game.Player.Health | 0;
    drawImage(statusBarGraphics.Background, 0, 0);
    drawImage((playerHp > 0) ? ((index = (max(comparePrimitives, 0, (statusBarGraphics.HealthFaces.length - 1) - (~(~(playerHp / 16)))) | 0), statusBarGraphics.HealthFaces[index][game.Player.CurrentFaceIndex])) : statusBarGraphics.Dead, 128, 1);
    drawImage(statusBarGraphics.Weapons[Player__get_CurrentWeapon(game.Player).StatusBarImageIndex], 247, 3);
    const drawNumber = (startX, maximumLength, value_1) => {
        let source;
        let numberAsString;
        const arg10 = max(comparePrimitives, 0, value_1) | 0;
        numberAsString = toText(printf("%d"))(arg10);
        (source = ((Array((maximumLength - numberAsString.length) + 1).join(" ")) + numberAsString), fold((x_2, value_4) => {
            let character;
            drawImage((character = value_4, statusBarGraphics.Font[(character === " ") ? 10 : (character.charCodeAt(0) - "0".charCodeAt(0))]), x_2, 13);
            return x_2 + 8;
        }, startX, source.split("")));
    };
    drawNumber(160, 3, playerHp);
    drawNumber(104, 1, game.Player.Lives);
    drawNumber(40, 6, game.Player.Score);
    drawNumber(15, 1, game.Level);
    drawNumber(209, 2, game.Player.Ammunition);
}

export function Dissolve_render(setPixel, game) {
    const matchValue = game.PixelDissolver;
    if (matchValue == null) {
    }
    else {
        const pixelDissolver = matchValue;
        iterate_1((tupledArg) => {
            const fromX = (~(~(tupledArg[0] * pixelDissolver.PixelSize))) | 0;
            const fromY = (~(~(tupledArg[1] * pixelDissolver.PixelSize))) | 0;
            const toY = (~(~((fromY + pixelDissolver.PixelSize) - 1))) | 0;
            iterate((zx) => {
                iterate((zy) => {
                    setPixel(4278190268, zx, zy);
                }, rangeDouble(fromY, 1, toY));
            }, rangeDouble(fromX, 1, ~(~((fromX + pixelDissolver.PixelSize) - 1))));
        }, pixelDissolver.DrawnPixels);
    }
}

